module.exports = __webpack_public_path__ + "static/rainbow-bace5c87c060da60ee564843e854c344.png";